module.exports = __webpack_public_path__ + "static/media/helper-woocommerce-1.b601cb6c.png";